import { render } from "./MasterDataKpiUsulanDetail.vue?vue&type=template&id=5cd2a111"
import script from "./MasterDataKpiUsulanDetail.vue?vue&type=script&lang=js"
export * from "./MasterDataKpiUsulanDetail.vue?vue&type=script&lang=js"

import "./MasterDataKpiUsulanDetail.vue?vue&type=style&index=0&id=5cd2a111&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__